var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPetrolBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_640_7945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.34307 12.8713C5.34307 12.046 4.741 11.3767 3.99856 11.3767C3.25612 11.3767 2.65405 12.046 2.65405 12.8713C2.65405 13.6967 3.25612 14.366 3.99856 14.366C4.741 14.366 5.34307 13.6967 5.34307 12.8713Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8303 12.8713C15.8303 12.046 15.2282 11.3767 14.4858 11.3767C13.7434 11.3767 13.1413 12.046 13.1413 12.8713C13.1413 13.6967 13.7434 14.366 14.4858 14.366C15.2282 14.366 15.8303 13.6967 15.8303 12.8713Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99874 13.4691C3.70189 13.4691 3.46094 13.2013 3.46094 12.8713C3.46094 12.5413 3.70186 12.2734 3.99874 12.2734C4.29562 12.2734 4.53654 12.5413 4.53654 12.8713C4.53654 13.2013 4.29562 13.4691 3.99874 13.4691Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4859 13.4691C14.1891 13.4691 13.9481 13.2013 13.9481 12.8713C13.9481 12.5413 14.189 12.2734 14.4859 12.2734C14.7828 12.2734 15.0237 12.5413 15.0237 12.8713C15.0237 13.2013 14.7828 13.4691 14.4859 13.4691Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.503174 8.68617H4.2678V4.50122H0.503174V8.68617Z",
    fill: "#FDC648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4104 5.99596H12.8726L12.3348 5.69703V4.50132L12.8726 4.20239H13.4104V5.99596Z",
    fill: "#FDC648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7057 9.98345C15.3362 9.51622 14.7809 9.28426 14.2213 9.28426H13.9481C13.7806 8.35161 13.2006 7.5765 12.4063 7.22345L12.3348 7.19176V3.90356L9.64573 4.95085V5.24978C9.64573 5.84763 9.64573 4.47004 9.64573 4.80035C9.64573 5.13034 9.64573 4.84275 9.64573 5.3982V5.69713H11.2591V9.28426V11.6757H6.95668L7.32452 10.7481C7.43691 10.3726 7.49446 9.97987 7.49446 9.58439C7.49473 9.08908 7.13331 8.6864 6.68775 8.6864H1.57868C1.13312 8.6864 0.771973 9.08784 0.771973 9.58318V9.95414C0.771973 10.1066 0.849966 10.2387 0.964245 10.3233C1.30925 10.5786 1.41467 11.0892 1.20436 11.4861L0.861524 12.1339C0.699371 12.3596 0.765249 12.6941 0.997865 12.8232C1.0546 12.8549 1.11698 12.8713 1.18044 12.8713H1.84758C1.84758 11.5525 2.81266 10.4799 3.99879 10.4799C5.18493 10.4799 6.15001 11.5525 6.15001 12.8713H12.3347C12.3347 11.5527 13.3001 10.4799 14.4859 10.4799C15.444 10.4799 15.7506 10.6901 16.0993 11.0777C16.0993 10.665 15.949 10.2914 15.7057 9.98345Z",
    fill: "#FDC648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8476 5.69693H2.9232V4.50122H1.8476V5.69693Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_640_7945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.596,
    height: 15.596,
    fill: "white",
    transform: "translate(0.503174 0.811279)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetrolBike);
export default __webpack_public_path__ + "static/media/petrol_bike.001f976a8363bd1f275e0d1d7d240cc6.svg";
export { ForwardRef as ReactComponent };